module.exports = __webpack_public_path__ + "img/no_favorite.95191f11.svg";